import React, { Component } from 'react';
import fetcher from '../API';
import Loading from '../components/loading';

class TranslateRow extends Component {

    handleSave = () => {
        const { text, index } = this.props;
        if (this.props.onSave) {
            this.props.onSave(index, text);
        }
    }

    handleChange = (e) => {
        const { index } = this.props;
        if (this.props.onChange) {
            this.props.onChange(index, e.target.value);
        }
    }

    handleCancel = () => {
        const { index } = this.props;
        if (this.props.onCancel) {
            this.props.onCancel(index);
        }
    }

    handleStartEdit = () => {
        const { index } = this.props;
        if (this.props.onStartEdit) {
            this.props.onStartEdit(index);
        }
    }

    render() {
        const { text, isEditMode, onCancel } = this.props || {};
        if (isEditMode) {
            return (
                <div className="input-group">
                    <input type="text"
                        className="form-control"
                        value={ text }
                        onChange={ this.handleChange }
                    />
                    <div className="input-group-append">
                        <button className="btn btn-secondary"
                            type="button"
                            onClick={ this.handleCancel }>
                            Cancel
          </button>
                        <button className="btn btn-info"
                            onClick={ this.handleSave }
                            type="button"
                        >
                            Save
          </button>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="alert alert-primary">
                    { text }
                    <button className="btn btn-info float-right btn-sm"
                        onClick={ this.handleStartEdit }
                        type="button"
                    >
                        Edit
          </button>
                </div>
            );
        }
    }
}



class ProductDescriptions extends Component {
    state = {
        isLoading: false,
        translations: [],
        editTranslations: [],
        editModeFlags: [],
    }

    componentDidMount() {
        const { productId } = this.props || {}
        this.loadTranslatedDescriptions(productId);
    }

    changeTranslation = (index, newText) => {
        let editTranslations = this.state.editTranslations;
        editTranslations[index] = newText;
        this.setState({ editTranslations });
    }

    cancelChangeTranslation = (index) => {
        let editModeFlags = this.state.editModeFlags;
        editModeFlags[index] = false;
        this.setState({ editModeFlags });
    }

    startEditTranslation = (index) => {
        let editModeFlags = this.state.editModeFlags;
        editModeFlags[index] = true;
        this.setState({ editModeFlags });
    }

    updateTranslatedDescriptions = (index, newText) => {
        let editModeFlags = this.state.editModeFlags;
        editModeFlags[index] = false;
        this.setState({ editModeFlags });

        const { translations } = this.state;
        const { descriptions, productId } = this.props;
        const url = `api/v1/translate/edit/product/${productId}`
        const data = {
            description: descriptions[index],
            before: translations[index],
            after: newText,
        }
        fetcher.post(url, data).then((response) => {
            this.loadTranslatedDescriptions();
            translations[index] = newText
            this.setState({
                translations
            })
        }).catch((error) => {
            this.setState({
                isLoading: false,
            });
        });
    }

    loadTranslatedDescriptions(productId) {
        if (!productId) {
            return;
        }
        const url = `api/v1/translate/product/${productId}`
        this.setState({ isLoading: true });
        fetcher.get(url).then((response) => {
            let translations = [];
            if (response.data && response.data.description) {
                translations = response.data.description;
            }
            let editTranslations = Array.from(translations);
            let editModeFlags = Array.from(translations);
            editModeFlags.fill(false);
            this.setState({
                isLoading: false,
                translations: translations,
                editTranslations: editTranslations,
                editModeFlags: editModeFlags,
            });
        }).catch((error) => {
            this.setState({
                isLoading: false,
            });
        });
    }

    render() {
        const { descriptions } = this.props || {};
        const {
            isLoading,
            translations,
            editTranslations,
            editModeFlags,
        } = this.state || {};

        let descView;
        if (descriptions) {
            descView = descriptions.map((desc, idx) => {
                let content = [];
                content.push(
                    <tr key={ idx }><td key={ idx }>{ desc }</td></tr>
                );
                if (translations && translations.length > idx) {
                    const editModeFlag = editModeFlags[idx]
                    let text = translations[idx];
                    if (editModeFlag) {
                        text = editTranslations[idx];
                    }
                    content.push(
                        <tr key={ 'translate' + idx }>
                            <td>
                                <TranslateRow key={ 'translate' + idx }
                                    text={ text }
                                    index={ idx }
                                    isEditMode={ editModeFlag }
                                    onStartEdit={ this.startEditTranslation }
                                    onSave={ this.updateTranslatedDescriptions }
                                    onCancel={ this.cancelChangeTranslation }
                                    onChange={ this.changeTranslation }
                                />
                            </td>
                        </tr>
                    )
                }
                return content;
            });
        }

        return (
            <div>
                <table className="table table-hover">
                    <tbody>
                        { descView }
                    </tbody>
                </table>

                { isLoading ? <Loading spinning /> : null }
            </div>
        )
    }
}

export default ProductDescriptions;